/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 22.11.24
 *
 */

let VueAppContainer = {}
console.log("createApp: VueAppContainer = ", VueAppContainer)

// export default VueAppContainer
let _resolveApp

// export default {
// 	App: null,
// 	appPromise: new Promise((resolve) => {
// 		_resolveApp = resolve;
// 	}),
// 	setApp(app) {
// 		this.App = app;
// 		console.log("createApp: VueAppContainer.App = ", this.App, ", _resolveApp = ", _resolveApp)
// 		_resolveApp(app);
// 	},
// };


export default VueAppContainer
